import { getEffectiveTranslations } from './i18n';

function t(lang, key) { return getEffectiveTranslations(lang||'en')[key]||key; }

// ── BeeLove Icebreaker Generator ──────────────────────────────────────────
// Generates personalized conversation starters based on both profiles

function getTemplates(lang) { return {
  shared_interest: [
    t(lang,'ice.t_interest1'),
    t(lang,'ice.t_interest2'),
    t(lang,'ice.t_interest3'),
  ],
  prompt_response: [
    t(lang,'ice.t_prompt1'),
    t(lang,'ice.t_prompt2'),
  ],
  lifestyle: [
    t(lang,'ice.t_lifestyle1'),
    t(lang,'ice.t_lifestyle2'),
  ],
  mbti: [
    t(lang,'ice.t_mbti1'),
    t(lang,'ice.t_mbti2'),
  ],
  zodiac: [
    t(lang,'ice.t_zodiac'),
  ],
  language: [
    "You both speak {lang} — surprise them with a message in {lang}?",
  ],
  age_gap: [
    t(lang,'ice.t_age'),
  ],
  universal: [
    t(lang,'ice.q1'),
    t(lang,'ice.t_local'),
    t(lang,'ice.q2'),
    t(lang,'ice.q3'),
    t(lang,'ice.q4'),
    t(lang,'ice.q5'),
    t(lang,'ice.t_dinner'),
    t(lang,'ice.q6'),
  ],
}; }

export function generateIcebreakers(me, them, count = 3, lang = 'en') {
  const suggestions = [];

  // Shared interests
  const myInterests    = new Set(me.interests || []);
  const theirInterests = (them.interests || []).filter(i => myInterests.has(i));
  theirInterests.forEach(interest => {
    if (suggestions.length >= 2) return;
    const templates = getTemplates(lang).shared_interest;
    const t = templates[Math.floor(Math.random() * templates.length)];
    suggestions.push({
      id:   `interest_${interest}`,
      text: t.replace(/{interest}/g, interest.toLowerCase()),
      type: 'interest',
      icon: '🎯',
    });
  });

  // MBTI
  if (me.mbti && them.mbti && me.mbti !== them.mbti && suggestions.length < 3) {
    const t = getTemplates(lang).mbti[0];
    suggestions.push({
      id:   'mbti',
      text: t.replace('{myMbti}', me.mbti).replace('{theirMbti}', them.mbti),
      type: 'mbti',
      icon: '🧠',
    });
  }

  // Shared language
  const myLangs    = new Set(me.languages || []);
  const sharedLang = (them.languages || []).find(l => myLangs.has(l) && l.toLowerCase() !== 'french' && l.toLowerCase() !== 'english');
  if (sharedLang && suggestions.length < 3) {
    suggestions.push({
      id:   `lang_${sharedLang}`,
      text: getTemplates(lang).language[0].replace(/{lang}/g, sharedLang),
      type: 'language',
      icon: '🗣',
    });
  }

  // Prompts
  const prompts = [them.prompt1, them.prompt2, them.prompt3].filter(p => p?.a);
  if (prompts.length > 0 && suggestions.length < 3) {
    const p = prompts[Math.floor(Math.random() * prompts.length)];
    suggestions.push({
      id:   'prompt',
      text: getTemplates(lang).prompt_response[1].replace('{prompt}', p.q),
      type: 'prompt',
      icon: '💬',
    });
  }

  // Fill with universals
  const used = new Set(suggestions.map(s => s.id));
  const universals = [...getTemplates(lang).universal].sort(() => Math.random() - 0.5);
  for (const u of universals) {
    if (suggestions.length >= count) break;
    const id = u.slice(0, 20);
    if (!used.has(id)) {
      suggestions.push({ id, text: u, type: 'universal', icon: '✨' });
      used.add(id);
    }
  }

  return suggestions.slice(0, count);
}

// Match expiry
export const MATCH_EXPIRY_DAYS = 7;

export function getMatchExpiryDate(matchedAt) {
  const d = new Date(matchedAt || Date.now());
  d.setDate(d.getDate() + MATCH_EXPIRY_DAYS);
  return d;
}

export function getDaysUntilExpiry(matchedAt) {
  const expiry = getMatchExpiryDate(matchedAt);
  const diff   = expiry - new Date();
  return Math.max(0, Math.ceil(diff / 86400000));
}

export function isExpired(matchedAt) {
  return getDaysUntilExpiry(matchedAt) === 0;
}
